import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class AssociationService {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
	}

	checkAssociations(entityId, callback) {
		const url = `/ecosystem/api/associations/${entityId}`;
		this._restClient.exec_get(url, callback);
	}

	streamCameraAssociations(entityId, entityType, streamType, callback) {
		// stream type options ("id", "entity")
		const args = { entityId, entityType, streamType };
		return this._rc.subscribe("ecosystem", "/cameraAssociations", args, (msg) => {
			const response = JSON.parse(msg);
			if (response && callback) {
				callback(null, response);
			}
		});
	}

	streamDeviceAssociations(entityId, entityType, streamType, deviceTypes, callback) {
		// stream type options ("id", "entity")
		const args = { entityId, entityType, streamType, deviceTypes };
		return this._rc.subscribe("ecosystem", "/deviceAssociations", args, (msg) => {
			const response = JSON.parse(msg);
			if (response && callback) {
				callback(null, response);
			}
		});
	}
}
